import { render, staticRenderFns } from "./Datalist.vue?vue&type=template&id=4d6384c8&scoped=true"
import script from "./Datalist.vue?vue&type=script&lang=js"
export * from "./Datalist.vue?vue&type=script&lang=js"
import style0 from "./Datalist.vue?vue&type=style&index=0&id=4d6384c8&prod&lang=pcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6384c8",
  null
  
)

export default component.exports